module.exports = __webpack_public_path__ + "img/expert1.72169a9a.png";